/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {StreamBankMutableList} from "./StreamBankMutableList";
import React from "react";

export const InnerStreamBankMutableList = props => (
    <StreamBankMutableList
        className="sb-mutable-list-override-container-inner sb-mutable-list-override-container-no-header"
        {...props}
    />
);
